import { Engine, SceneActivationContext } from 'excalibur';
import { BaseLevel } from './baseLevel';
import { Dummy } from './dummy';
import { GlobalGameStore } from '@game-libs/global-game-store';

export class DummyLevel extends BaseLevel {
  private dummy: Dummy = new Dummy();

  protected onLevelInitialize(engine: Engine): void {

    const { state: globalState } = GlobalGameStore();
    if (globalState.globalVariables.value.killedDummy) {
      return;
    }

    this.dummy.pos = this.getAttackTargetPosition();
    this.add(this.dummy);
  }

  protected onLevelDeactivate(ctx: SceneActivationContext): void {
    // Empty for now
  }
}
